module.exports = __webpack_public_path__ + "static/img/6.209aff3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/6.png
// module id = 05CK
// module chunks = 0